import { TaxonomyActionType } from '@modules/taxonomy/store/taxonomyActionType';
import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import { useCallback } from 'react';
import { useMuiModalContext } from '../../Modal/ModalContext';
import { CreateReasonInProgressDialog } from '../CreateReasonInProgressDialog';

interface UseShowCreateNewReasonInProgressDialogProps {
  closeExistingCreateNewReasonDialog: () => void;
  openCreateNewReasonDialog: () => void;
}

export const useShowCreateNewReasonInProgressDialog = ({
  closeExistingCreateNewReasonDialog,
  openCreateNewReasonDialog,
}: UseShowCreateNewReasonInProgressDialogProps) => {
  const dispatch = useTaxonomyStore(({ dispatch }) => dispatch);

  const isCreateNewReasonV3InProgress = useTaxonomyStore(
    ({ createReasonV3State }) => createReasonV3State.visual?.isModalMinimised,
  );

  const { openModal, closeModal } = useMuiModalContext();

  const closeAndResetExistingCreateNewReasonDialog = useCallback(() => {
    dispatch({
      type: TaxonomyActionType.RESET_CREATE_REASONV3_STATE,
    });

    closeExistingCreateNewReasonDialog();
  }, [closeExistingCreateNewReasonDialog, dispatch]);

  const showCreateNewReasonInProgressDialog = useCallback(() => {
    if (isCreateNewReasonV3InProgress) {
      openModal({
        contentComponent: () => (
          <CreateReasonInProgressDialog
            closeCreateReasonInProgressDialog={closeModal}
            closeExistingCreateNewReasonDialog={
              closeAndResetExistingCreateNewReasonDialog
            }
            openCreateNewReasonDialog={openCreateNewReasonDialog}
          />
        ),
        modalProps: {},
      });

      return;
    }
  }, [
    closeAndResetExistingCreateNewReasonDialog,
    closeModal,
    isCreateNewReasonV3InProgress,
    openCreateNewReasonDialog,
    openModal,
  ]);

  return {
    isCreateNewReasonInProgress: isCreateNewReasonV3InProgress,
    showCreateNewReasonInProgressDialog,
  };
};
